// extracted by mini-css-extract-plugin
export var distanceExample = "_006-search-with-typo-tolerance-module--distance-example--33oyx";
export var distanceExamples = "_006-search-with-typo-tolerance-module--distance-examples--3T8Ji";
export var distanceRemove = "_006-search-with-typo-tolerance-module--distance-remove--3Afd_";
export var distanceSearchedText = "_006-search-with-typo-tolerance-module--distance-searched-text--2ql26";